<template>
  <v-container>
    <v-row>
      <v-col v-for="cover in covers" cols="6" sm="4" md="3" :key="cover.id">
        <a v-if="cover.url" :href="cover.url" target="_blank">
          <v-img max-height="60vh" contain :src="cover.link"></v-img>
        </a>
        <a v-else>
          <v-img max-height="60vh" contain :src="cover.link"></v-img>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CoversContent",
  computed: mapState(["loadingCovers", "covers"]),
  mounted() {
    if (!this.covers.length) this.$store.dispatch("cargarCovers");
  }
};
</script>

<style scoped>
</style>